<div class="loading-container">
  <div class="loading-spinner"></div>
  <p>{{ loadingService.text }}</p>
</div>
